<template>
  <div class="text-center">
    <div v-if="loading">
      <img :src="imagePreview" class="img-fluid mb-4" style="max-height: 400px;" />
      <p class="text-muted">辨識中，請稍後……</p>
    </div>

    <div v-else-if="ocrText">
      <p class="text-success font-weight-bold mb-2">辨識完成！</p>
      <pre class="bg-light p-3 rounded text-left text-wrap">{{ ocrText }}</pre>
      <button @click="confirmText" class="btn btn-primary mt-4">確認文字</button>
    </div>

    <div v-else>
      <p class="text-danger py-3">辦識失敗，請重新檢視圖片格式(小於10Mb)與圖片像素(長寬低於10000px)是否符合相關上傳規定。</p>
    </div>
  </div>
</template>

<script>
import api from '@/store/api'

export default {
  props: {
    croppedImage: Blob
  },
  data () {
    return {
      loading: true,
      ocrText: null,
      imagePreview: ''
    }
  },
  mounted () {
    this.getOCR()
  },
  methods: {
    confirmText() {
      this.$emit('next', this.ocrText)
    },
    getOCR () {
      if (!this.croppedImage) return

      this.imagePreview = URL.createObjectURL(this.croppedImage)

      const formData = new FormData()
      formData.append('file', this.croppedImage)

      api.post('/textract', formData, {
        headers: {
          ...api.defaults.headers.common,
          'Content-Type': 'multipart/form-data'
        }
      })
        .then((response) => {
          let text = ''
          for (let value of response.data) {
            if (value.Text && value.BlockType === 'LINE') {
              text += value.Text + ' '
            }
          }
          this.ocrText = text
          this.$emit('next', text)
        })
        .catch((err) => {
          console.error('OCR API 錯誤:', err)
          this.ocrText = null
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  beforeDestroy() {
    URL.revokeObjectURL(this.imagePreview)
  }
}
</script>
